import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@tekman/onmat/service/generic';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { Subscription } from 'rxjs';
import { ErrorObject } from '../error-404/error-notfound.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { appRoutes, Language } from '@tekman/onmat/constants';
import { GroupsFacade } from '@tekman/onmat/store/group';
import { take } from 'rxjs/internal/operators';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  errorInfo: ErrorObject = {
    title: 'f.error-page.not-found.title',
    description: 'f.error-page.not-found.description',
    img: '/assets/errors/No-puedes-ver-actividad.png',
    buttonText: 'f.error-page.not-found.button.message',
    button: true,
  };
  subscription: Subscription;
  router = inject(Router);
  groupsFacade = inject(GroupsFacade);
  constructor(
    private readonly profileFacade: ProfileFacade,
    private readonly userService: UserService,
    private route: ActivatedRoute,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    if (!this.translateService.currentLang) {
      const schoolLanguage = (this.userService.getUser().attributes['schoolLanguage'] as string)?.toUpperCase();
      // Translations only exist for ESP, CAT, MEX and ENG; any other value (ECU, EUSK...) falls back to ESP.
      const availableLanguages: string[] = [Language.ESP, Language.CAT, Language.MEX, Language.ENG];
      this.translateService.use(availableLanguages.includes(schoolLanguage) ? schoolLanguage : Language.ESP);
    }
    this.setError(params['type']);
  }

  redirectUrl(): void {
    if (this.errorInfo.title !== 'f.error-page.not-found.title') {
      this.logout();
    } else {
      this.groupsFacade.selectedGroup$.pipe(take(1)).subscribe(group => {
        if (group?.id) {
          this.router.navigate([appRoutes.itineraries, group.id]);
        } else {
          this.logout();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

  private logout(): void {
    this.userService.logout();
    this.profileFacade.removeProfile();
  }

  private setError(type: string) {
    switch (type) {
      case 'group':
        this.errorInfo.title = 'f.error-page.student-not-group.title';
        this.errorInfo.description = 'f.error-page.student-not-group.description';
        this.errorInfo.buttonText = 'f.error-page.button.message';
        this.errorInfo.img = '/assets/errors/no-encontramos-squad.png';
        break;
      case 'license':
        this.errorInfo.title = 'f.error-page.school-not-licenses.title';
        this.errorInfo.description = 'f.error-page.school-not-licenses.description';
        this.errorInfo.buttonText = 'f.error-page.button.message';
        this.errorInfo.img = '/assets/errors/alarm.png';
        break;
    }
  }
}
